// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#button[data-v-52720118]{border-style:inherit}.loading svg[data-v-52720118]{position:absolute;top:50%;left:50%;margin-top:-8px;margin-left:-8px;display:inline-block}a[disabled][data-v-52720118],button[disabled][data-v-52720118]{opacity:.5;cursor:not-allowed}", ""]);
// Exports
module.exports = exports;
